import { rows, DataGrid } from "colbi_web_ui/lib/components";
import { parseFilter } from "colbi_web_ui/lib/utils";
import App from "../controllers/App/App";
import { checkForCustomFragment } from "../utils/queryUtils";
import GenericViewsToolbar from "../components/GenericViewsToolbar/GenericViewsToolbar";
import { getConfigVariable } from "../config/config";
import { hasModule } from "../utils/utils";
import AppNewLogic from "../controllers/App/AppNewLogic";

const queries = (args = {}) => {
    const entityResource = args.entity;
    const result = [];

    const customEntityFragment = checkForCustomFragment("", args.entity);

    if (customEntityFragment) {
        result.push({
            resource: entityResource,
            args: {
                projectId: args.projectId,
                fiscalYear: args.fiscalYear,
                importId: args.importId,
                modulePrefix: args.modulePrefix,
                locale: args.locale,
                filter: args.filter
                    ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                    : undefined,
                sort: args.sort
                    ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                    : undefined,
                page: parseInt(args.page, 10) || 0,
                pageSize: parseInt(
                    args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                ),
            },
            body: `__typename, items{ ...${entityResource} }, hasMore, total, totalizers, filters(projectId:$projectId,fiscalYear:$fiscalYear,modulePrefix:$modulePrefix,importId:$importId,locale:$locale){ prop, name, type, list, disableOperators, mandatory }`,
            downloadable: true,
            xlsxTranslation: entityResource,
            isDatagridReq: true,
        });
        if (["balance_sheet", "profit_and_loss"].includes(entityResource)) {
            result.push(
                {
                    resource: `${args.entity}_taxonomy_export`,
                    args: {
                        projectId: args.projectId,
                        fiscalYear: args.fiscalYear,
                        importId: args.importId,
                        modulePrefix: args.modulePrefix,
                        locale: args.locale || "en",
                        filter: args.filter
                            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                            : undefined,
                        page: parseInt(args.page, 10) || 0,
                    },
                    body: `report`,
                    downloadable: true,
                    downloadOnly: true,
                    xlsxTranslation: args.entity,
                },
                {
                    resource: `${args.entity}_accounting_export`,
                    args: {
                        projectId: args.projectId,
                        fiscalYear: args.fiscalYear,
                        importId: args.importId,
                        modulePrefix: args.modulePrefix,
                        locale: args.locale || "en",
                        filter: args.filter
                            ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                            : undefined,
                        page: parseInt(args.page, 10) || 0,
                    },
                    body: `report`,
                    downloadable: true,
                    downloadOnly: true,
                    xlsxTranslation: args.entity,
                },
            );
        }
    } else {
        result.push(
            {
                resource: "generic_views",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    entity: args.entity,
                    filter: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    sort: args.sort
                        ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                        : undefined,
                    page: parseInt(args.page, 10) || 0,
                    pageSize: parseInt(
                        args.pageSize || getConfigVariable("REACT_APP_DEFAULT_PAGE_SIZE"),
                    ),
                },
                body: `__typename, items, headerItems, hasMore, total, totalizers, entity, filters(projectId:$projectId,fiscalYear:$fiscalYear,modulePrefix:$modulePrefix,entity:$entity,importId:$importId){ prop, name, type, list, disableOperators, mandatory }`,
                isDatagridReq: true,
            },
            {
                resource: "generic_views_export",
                args: {
                    projectId: args.projectId,
                    fiscalYear: args.fiscalYear,
                    importId: args.importId,
                    modulePrefix: args.modulePrefix,
                    entity: args.entity,
                    filter: args.filter
                        ? { type: "[FilterInput!]", value: parseFilter(args.filter) }
                        : undefined,
                    sort: args.sort
                        ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                        : undefined,
                    page: parseInt(args.page, 10) || 0,
                },
                body: `__typename, items, headerItems, hasMore, total, totalizers, entity, filters(projectId:$projectId,fiscalYear:$fiscalYear,modulePrefix:$modulePrefix,entity:$entity,importId:$importId){ prop, name, type, list, disableOperators, mandatory }`,
                downloadable: true,
                downloadOnly: true,
                xlsxTranslation: args.entity,
            },
        );
    }

    result.push({
        resource: "data_files_types_present",
        args: {
            projectId: args.projectId,
        },
        body: "hasSource, hasLegal",
    })

    return result.filter((r) => !!r.resource);
};

const GenericReportsController = (props) => {
    const { modules } = props;
    const modifiedProps = { ...props, hideNewMenu: true, hasHeroBanner: true, }
    const Controller = hasModule(modules, "new_navigation") ? AppNewLogic : App;
    return <Controller {...modifiedProps} />;
};

const genericReportsByFile = (path, navigation, exact, title, navByImportId = false) => ({
    path,
    navigation,
    component: (props) => GenericReportsController(props),
    queries,
    exact,
    navByImportId,
    title,
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                items: "query(0).list",
                header: "query(0).header",
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                total: "query(0).metadata.total",
                projectModules: "query(1)",
                totalizers: "query(0).totalizers",
                toolbar: GenericViewsToolbar,
                toolbarProps: {
                    data: "query(0).list",
                },
            },
        },
    ],
});

export default genericReportsByFile;
